<template>
  <div class="authentication-container">
    <div class="authentication-overlay">
      <div
        id="authentication-content"
        class="authentication-content"
      >
        <div style="text-align: center">
          <mastery-icon />
        </div>
        <div class="box">
          <div class="text-lg text-primary font-semibold title">
            {{ title }}
          </div>
          <div class="text-sm text-tertiary font-regular subtitle">
            {{ subtitle }}
          </div>
          <div class="subtitle" />
          <auth-mastery-input
            :error="errors['email']"
            :field="email"
            label="Email"
            placeholder="Enter your email"
            type="email"
            @enter="submit"
            @input-change="handleInputChange($event, 'email')"
          />
          <button
            class="button-reset button-primary font-semibold flexbox-row button-flex"
            :class="{ disabled: loading, sent: sent }"
            @click="submit"
          >
            <span v-if="sent">
              <icon
                name="check-circled"
              />
            </span>
            <span>{{ buttonText }}</span>
          </button>
          <div class="flexbox-row justify-center">
            <span class="text-sm font-semibold text-primary link-underline">
              Back to
              <router-link class="no-visited" :to="{ name: 'mastery#signIn' }">
                log in
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Authentication from '@/mixins/authentication';
import MasteryIcon from '@components/mastery/MasteryIcon';
import AuthMasteryInput from '@components/ui/AuthMasteryInput';
import Icon from '@/components/singletons/icon';

export default {
  components: { MasteryIcon, AuthMasteryInput, Icon },
  mixins: [Authentication],
  data() {
    return {
      sent: false,
    };
  },
  computed: {
    title() {
      return this.sent ? 'Link Sent' : 'Reset Password';
    },
    subtitle() {
      return this.sent
        ? 'Check your email to reset your password.'
        : 'Enter your email to receive a reset link.';
    },
    buttonText() {
      return this.sent ? 'Link Sent' : 'Continue';
    },
  },
  methods: {
    submit() {
      if (this.sent) {
        this.$router.push({ name: 'mastery#signIn' });
        return;
      }
      this.loading = true;
      this.clearAuthenticationErrors();
      this.$store.dispatch('session/resetPassword', { email: this.email }).then(response => {
        this.sent = true;
      }).catch(e => {
        this.handleErrors(e, 'Forgot Password');
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang='scss' scoped>
  @use '@/style/authentication-v2.scss' as *;

  button.sent {
    background-color: var(--fg-success-primary);
  }

  button.button-flex {
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }
</style>
